import React from 'react';

export default function(props) {
    return (
        <React.Fragment>
            <h4>
                Событие прошло
            </h4>
            <div className="row">
                Событие уже прошло.
            </div>
        </React.Fragment>
    )
}
